export function getHostNameFromUrl(url: string): string {
  const a = document.createElement('a')
  a.href = url
  return a.hostname
}
